import React, { useState, useEffect, useRef } from 'react'
import { EmptyPlaceholder } from '../../../../components/placeholder';
import { priceFormat } from '../../../../utils/common';
import { goToPage } from '../../utils';
import { queryDiscountCouponPage } from '../../api';
import PopupBottomModal from '../../../../components/popup-bottom-modal';
import VipCouponCard from '../../../../components/vip-coupon-card';
import './index.less'
import { trackGdp } from '../../../../utils/gio-report';
import { getSystemMallCoupon } from '../../pages/home';
const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'


const AgreementRow = ({
    detailRuleImgUrl,
    content,
    credit,
    isXpCarOwner,
    memberGoods,
    changeOriginMemberGoods
}) => {
    const showCredit = isXpCarOwner || (!isXpCarOwner && credit > 0)
    const [redPackModalVisible, setRedPackModalVisible] = useState<boolean>(false)
    const [currentTab, setCurrentTab] = useState<'canuse' | 'cannotuse'>('canuse')
    const [canuseList, setCanuseList] = useState<any>([])
    const [cannotuseList, setCannotuseList] = useState<any>([])
    const canuseCouponistRef = useRef<any>(null)
    const cannotuseCouponistRef = useRef<any>(null)
    const [canusePageNo, setCanusePageNo] = useState<number>(1)
    const [cannotusePageNo, setCannotusePageNo] = useState<number>(1)
    const [haveReceive, setHaveReceive] = useState<boolean>(false)
    if (showCredit) {
        // 上报埋点
        trackGdp('P11222', 'B013', {
            points: credit
        })
    }

    useEffect(() => {
        if (redPackModalVisible) {
            // 上报埋点
            trackGdp('P11222', 'B014', {
                'mall_coupon': `${memberGoods?.discountCouponDto?.couponPlanName}(${memberGoods?.discountCouponDto?.couponPlanId})`,
                'group_id': memberGoods?.homepageGroupId,
                'group_name': memberGoods?.homepageGroupName,
            })
        }
    }, [redPackModalVisible])

    const goToRule = () => {
        const { origin, pathname } = window.location
        goToPage(`${origin}${pathname}#/rules?imgUrl=${encodeURIComponent(detailRuleImgUrl)}`)
    }

    const goToAgreement = () => {
        const { origin, pathname } = window.location
        goToPage(`${origin}${pathname}#/agreement`)
    }
    const changeAutoToFalse = () => {
        let newMemberGoods = { ...memberGoods }
        newMemberGoods.couponPackGoodsList = newMemberGoods?.couponPackGoodsList?.map(i => {
            return {
                ...i,
                autoReceiveDiscountCoupon: false
            }
        })
        newMemberGoods.chargeCardGoodsList = newMemberGoods?.chargeCardGoodsList?.map(i => {
            return {
                ...i,
                autoReceiveDiscountCoupon: false
            }
        })
        newMemberGoods.memberCardList = newMemberGoods?.memberCardList?.map(i => {
            return {
                ...i,
                autoReceiveDiscountCoupon: false
            }
        })
        // 回调更改原始数据
        changeOriginMemberGoods(newMemberGoods)
    }
    const getCanuseRedPackData = async (pageNo?: number) => {
        let autoReceiveCoupon = memberGoods?.memberCardList?.some(i => i.autoReceiveDiscountCoupon) || memberGoods?.couponPackGoodsList?.some(i => i.autoReceiveDiscountCoupon) || memberGoods?.chargeCardGoodsList?.some(i => i.autoReceiveDiscountCoupon)
        let params: any = { autoReceiveCoupon: haveReceive ? false : Boolean(autoReceiveCoupon), pageNo: pageNo || 1, pageSize: 10, state: 1 }
        if (autoReceiveCoupon) { params.couponPlanId = memberGoods?.discountCouponDto?.couponPlanId }

        let redPackRes = await queryDiscountCouponPage(params)
        let newlist: any = []
        if (redPackRes?.code === 200) {
            newlist = redPackRes?.data?.coupons?.records
            if (!redPackRes?.data?.showConfigCouponToReceive) {

                changeAutoToFalse()
                // canuseList = [{ ...memberGoods?.discountCouponDto, showReceiveBtn: true }].concat(canuseList)
            } else {
                newlist = (!pageNo && !haveReceive) ? [{ ...memberGoods?.discountCouponDto, showReceiveBtn: true }].concat(newlist) : newlist
            }
            setCanuseList(haveReceive ? newlist : canuseList.concat(newlist || []))
        }
    }

    const getCannotuseRedPackData = async (pageNo?: number) => {
        let autoReceiveCoupon = memberGoods?.memberCardList?.some(i => i.autoReceiveDiscountCoupon) || memberGoods?.couponPackGoodsList?.some(i => i.autoReceiveDiscountCoupon) || memberGoods?.chargeCardGoodsList?.some(i => i.autoReceiveDiscountCoupon)
        let params: any = { autoReceiveCoupon: haveReceive ? false : Boolean(autoReceiveCoupon), pageNo: pageNo || 1, pageSize: 10, state: 2 }
        if (autoReceiveCoupon) { params.couponPlanId = memberGoods?.discountCouponDto?.couponPlanId }
        let redPackRes = await queryDiscountCouponPage(params)
        if (redPackRes?.code === 200) {
            setCannotuseList((cannotuseList.length && pageNo) ? cannotuseList.concat(redPackRes?.data?.coupons?.records || []) : (redPackRes?.data?.coupons?.records || []))
        }
    }

    const onCanuseListScroll = (e) => {
        e?.stopPropagation();
        const listDom: any = canuseCouponistRef.current;
        if (listDom) {
            const isEnd =
                listDom.scrollTop + 50 >= listDom.scrollHeight - listDom.clientHeight;
            if (isEnd) {
                // 已经到底了
                // if (canuseList?.length >= canuseTotal) {
                //     return;
                // }
                let nextPage = canusePageNo + 1;
                // 如果计算出来的数据量比已有的数据还多，说明上一次还没加载成功，重新来
                if (canusePageNo * 10 > canuseList?.length) {
                    nextPage = canusePageNo;
                    return
                }
                setCanusePageNo(nextPage)
                getCanuseRedPackData(nextPage)
            }
        }
    };

    const onCannotuseListScroll = (e) => {
        e?.stopPropagation();
        const listDom: any = cannotuseCouponistRef.current;
        if (listDom) {
            const isEnd =
                listDom.scrollTop + 50 >= listDom.scrollHeight - listDom.clientHeight;
            if (isEnd) {
                // 已经到底了
                // if (cannotuseList?.length >= cannotuseTotal) {
                //     return;
                // }
                let nextPage = canusePageNo + 1;
                // 如果计算出来的数据量比已有的数据还多，说明上一次还没加载成功，重新来
                if (cannotusePageNo * 10 > cannotuseList?.length) {
                    nextPage = canusePageNo;
                    return
                }
                setCannotusePageNo(nextPage)
                getCannotuseRedPackData(nextPage)
            }
        }
    };

    const getRedPackData = async (pageNo?: number) => {
        // 上报埋点
        trackGdp('P11222', 'B015', {
            'system_mall_coupon': getSystemMallCoupon(content)
        })
        await getCanuseRedPackData(pageNo)
        await getCannotuseRedPackData(pageNo)
        setRedPackModalVisible(true)
    }
    const reset = () => {
        setCannotusePageNo(1)
        setCanusePageNo(1)
        setCanuseList([])
        setCannotuseList([])
    }
    useEffect(() => {
        if (cannotusePageNo === 1 && canusePageNo === 1 && !cannotuseList?.length && !canuseList?.length && haveReceive) {
            getRedPackData()
            setHaveReceive(false)
        }
    }, [
        cannotusePageNo,
        canusePageNo,
        canuseList,
        cannotuseList,
        haveReceive
    ])
    useEffect(() => {
        if (haveReceive) {
            reset()
            changeAutoToFalse()
        }
    }, [haveReceive])
    return (
        <div className='agreement-row'>
            {
                showCredit && (
                    <div className='credit-info'>
                        {!!content?.maxUseCreditAmount && `积分价：${content?.maxUseCreditAmount}积分`}
                        <span className='value'>{content?.maxUseCreditAmount ? `（当前${credit}积分可用）` : `当前${credit}积分可用`}</span>
                    </div>
                )
            }
            <div className={`privacy-row`}>
                支付即同意
                <span className='agreement' onClick={goToAgreement}>《购买协议》</span>
                <div className='devide-line'></div>
                <span className='rule' onClick={goToRule}>详细规则</span>
                <div onClick={() => getRedPackData()} className='my-red-pack'>我的抵扣红包</div>
                <img alt='' className='icon' src={`${CHARGE_CDN}/chargeVip/arrow-right.png`} />
            </div>
            <PopupBottomModal
                visible={redPackModalVisible}
                title={'VIP抵扣红包'}
                onClose={() => {
                    reset()
                    setRedPackModalVisible(false)
                }}
                contentClassName='red-pack-popup-bottom-modal-content'
                pageClassName='charge-vip-home'
            >
                <div className='red-pack-content'>
                    <div className='red-pack-tabs'>
                        <div key='canuse' className={`red-pack-tab ${currentTab === 'canuse' ? 'active-tab' : ''}`} onClick={() => {
                            // 上报埋点
                            trackGdp('P11222', 'B016', {
                                tabType: '可用红包'
                            })
                            setCurrentTab('canuse')
                        }
                        }>可用红包</div>
                        <div key='cannotuse' className={`red-pack-tab ${currentTab === 'cannotuse' ? 'active-tab' : ''}`} onClick={() => {
                            // 上报埋点
                            trackGdp('P11222', 'B016', {
                                tabType: '不可用红包'
                            })
                            setCurrentTab('cannotuse')
                        }}>不可用红包</div>
                    </div>
                    {currentTab === 'canuse'
                        ?
                        <div className='vip-coupon-list' key={'canuse-vip-coupon-list'} onScroll={onCanuseListScroll} ref={canuseCouponistRef}>
                            {canuseList?.length
                                ?
                                canuseList?.map((canuseItem, index) => {
                                    return <div key={`canuselist-${canuseItem?.couponId}-${index}`}>
                                        <VipCouponCard
                                            couponInfo={canuseItem}
                                            className='vip-coupon'
                                            afterReceive={async () => {
                                                setHaveReceive(true)
                                            }} />
                                    </div>
                                })
                                :
                                <EmptyPlaceholder text={'暂无可用卡券'}></EmptyPlaceholder>
                            }
                        </div>
                        :
                        <div className='vip-coupon-list' key={'cannotuse-vip-coupon-list'} onScroll={onCannotuseListScroll} ref={cannotuseCouponistRef}>
                            {
                                cannotuseList?.length
                                    ?
                                    cannotuseList?.map((cannotuseItem, index) => {
                                        return <div key={`cannotuselist-${cannotuseItem?.couponId}-${index}`}>
                                            <VipCouponCard couponInfo={cannotuseItem} disabled={true} className='vip-coupon' />
                                        </div>
                                    })
                                    :
                                    <EmptyPlaceholder text={'暂无可用卡券'}></EmptyPlaceholder>
                            }
                        </div>
                    }

                    {currentTab === 'canuse' && !!canuseList?.length && <div className='red-pack-list-tip'>展示近半年的VIP抵扣红包～ </div>}
                    {currentTab === 'cannotuse' && !!cannotuseList?.length && <div className='red-pack-list-tip'>展示近半年的VIP抵扣红包～ </div>}
                </div>
            </PopupBottomModal>
        </div>
    )
}

export default AgreementRow